﻿import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Context, { context_type } from '@Util/Context';
import * as Api from '@Util/Api';
import { apiBase } from '@Util/GlobalValues';
import { str_isEmpty } from '@Util/Utils';

import Popup from '@Elements/Popup/Popup';
import Textarea_With_Label from '@Elements/FormElements/Textarea_With_Label';
import Submit_Button from '@Elements/FormElements/Submit_Button';

import { Popup_Edit_Bulletin_Props } from '@Util/Types';

export default function Edit_Bulletin_Popup(props: Popup_Edit_Bulletin_Props): JSX.Element {
    const { t } = useTranslation();
    const { bulletin_board, fetch_bulletin_board, set_status_update }: context_type = useContext(Context);

    const [bulletin, set_bulletin] = useState<string>("");
    const [ongoing_submission, set_ongoing_submission] = useState<boolean>(false);

    useEffect(() => {
        if (!str_isEmpty(bulletin_board)) {
            set_bulletin(bulletin_board);
        }
    }, [bulletin_board]);

    const handle_form_submission = useCallback(async (e: React.FormEvent) => {
        e.preventDefault();
        set_ongoing_submission(true);

        try {
            await Api.callApi(`${apiBase}/UpdateGlobalReminder`, { text: bulletin });

            set_status_update({
                visible: true,
                text: t('Text.ApiSaved'),
                type: "Success"
            });

            props.set_open(false);
        } catch (err) {
            console.error(err.message);
            set_status_update({
                visible: true,
                text: t('Text.ApiError'),
                type: "Error"
            });
        } finally {
            set_ongoing_submission(false);
            fetch_bulletin_board();
        }
    }, [bulletin, t, set_status_update, props, fetch_bulletin_board]);

    return (
        <Popup
            open={props.open}
            set_open={props.set_open}
            title={t('Text.EditBulletinBoard')}
            disable_close_action={false}
        >
            <form onSubmit={handle_form_submission}>
                <Textarea_With_Label
                    id="edit_bulletin_board_textarea"
                    label={t('Label.BulletinBoard')}
                    value={bulletin}
                    onChange={(e) => set_bulletin(e.target.value)}
                    error={false}
                    rows={8}
                />
                <Submit_Button
                    text={t('Button.Save')}
                    disabled={ongoing_submission}
                    loading={ongoing_submission}
                />
            </form>
        </Popup>
    );
}